class ApiError extends Error {
    constructor(api, error) {
        super(`${api} raises error`, error);
    }
}
export default ApiError;
